import React, { useEffect, useState } from "react";
import { Reveal, SectionHeader } from "@/components/ui-blocks/Reveal";
import { api, endpoints } from "@/lib/api";
import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";
import { Expand } from "lucide-react";

export const GallerySection = ({ limit = 8 }) => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get(endpoints.gallery).then(setItems).catch(() => {}); }, []);
  const list = items.slice(0, limit);
  return (
    <section id="gallery" className="surface-tint">
      <div className="container-wide py-16 lg:py-24">
        <SectionHeader eyebrow="Gallery" title="Field moments, honest and unstaged." lead="A visual thread through our recent work — relief, education, medical, environmental and community programs." />
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
          {list.map((g, i) => (
            <Reveal key={g.id} delay={i * 0.03}>
              <Dialog>
                <DialogTrigger asChild>
                  <button data-testid={`gallery-item-${g.id}`} className="group relative aspect-[4/3] overflow-hidden rounded-lg border border-[hsl(var(--border))] focus-ring w-full">
                    <img loading="lazy" src={g.image} alt={g.title} className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-[1.03]" />
                    <div className="absolute inset-0 bg-[hsl(var(--navy))]/0 group-hover:bg-[hsl(var(--navy))]/25 transition-colors" />
                    <span className="absolute bottom-2 right-2 h-8 w-8 rounded-md bg-white/90 grid place-items-center opacity-0 group-hover:opacity-100"><Expand className="h-4 w-4 text-[hsl(var(--navy))]" /></span>
                    <span className="absolute bottom-2 left-2 text-xs text-white font-medium bg-black/70 px-2 py-0.5 rounded">{g.category}</span>
                  </button>
                </DialogTrigger>
                <DialogContent className="max-w-3xl p-0 overflow-hidden">
                  <img src={g.image} alt={g.title} className="w-full h-auto" />
                  <div className="p-4 bg-card">
                    <div className="text-xs uppercase tracking-widest text-[hsl(var(--green))]">{g.category}</div>
                    <h3 className="heading-3 mt-1 text-lg">{g.title}</h3>
                  </div>
                </DialogContent>
              </Dialog>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
